.root {
	width: 100%;
}

.header {
	margin: 0;
}

.trigger {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 24px;
	width: 100%;
	border: 0;
	background: transparent;
	cursor: pointer;
	text-align: left;
	font: inherit;
}

.icon {
	flex: 0 0 auto;
	line-height: 1;
	transition: transform 0.2s ease;
}

.trigger[data-state="open"] .icon {
	transform: rotate(45deg);
}

.content {
	overflow: hidden;
}

.content[data-state="open"] {
	animation: accordionSlideDown 0.2s ease-out;
}

.content[data-state="closed"] {
	display: none;
}

@keyframes accordionSlideDown {
	from {
		height: 0;
	}

	to {
		height: var(--radix-accordion-content-height);
	}
}

@keyframes accordionSlideUp {
	from {
		height: var(--radix-accordion-content-height);
	}

	to {
		height: 0;
	}
}
